import { SHOW_ASSET_FORM, HIDE_ASSET_FORM, SET_OPTIONS, SHOW_PRINT_LABEL, HIDE_PRINT_LABEL, SHOW_MAINTENANCE, HIDE_MAINTENANCE, SHOW_MAINTENANCE_RECORD, HIDE_MAINTENANCE_RECORD } from './types'

const initialState = {
  form: {
    show: false,
    data: {},
  },
  options: {
    categories: [],
    ownerships: [],
    employees: [],
    places: [],
  },
  print: {
    show: false,
    data: {},
  },
  maintenance: {
    show: false,
    data: {},
  },
  maintenanceRecord: {
    show: false,
    data: {},
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOW_ASSET_FORM:
      return {
        ...state,
        form: {
          show: true,
          data: action.data
        }
      };
    case HIDE_ASSET_FORM:
      return {
        ...state,
        form: {
          show: false,
          data: {}
        }
      };
    case SET_OPTIONS:
      return {
        ...state,
        options: action.options
      };
    case SHOW_PRINT_LABEL:
      return {
        ...state,
        print: {
          show: true,
          data: action.data
        }
      };
    case HIDE_PRINT_LABEL:
      return {
        ...state,
        print: {
          show: false,
          data: {}
        }
      };
    case SHOW_MAINTENANCE:
      return {
        ...state,
        maintenance: {
          show: true,
          data: action.data
        }
      };
    case HIDE_MAINTENANCE:
      return {
        ...state,
        maintenance: {
          show: false,
          data: {}
        }
      };
    case SHOW_MAINTENANCE_RECORD:
      return {
        ...state,
        maintenanceRecord: {
          show: true,
          data: action.data
        }
      };
    case HIDE_MAINTENANCE_RECORD:
      return {
        ...state,
        maintenanceRecord: {
          show: false,
          data: {}
        }
      };
    default:
      return state;
  }
};

export default reducer;
